import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.css']
})
export class MessageModalComponent {
  message: string = "";
  @Output() onOkEmitter = new EventEmitter<string>();

  setMessage(message:string){
    this.message = message;
  }

  onOk(){
    this.onOkEmitter.emit('ok');
    this.message = "";
  }


}
